export default __webpack_public_path__ + "static/media/new7.bfe04d42.jpg";